import(/* webpackMode: "eager" */ "/vercel/path0/app/deals/error.tsx");
